/* eslint-disable array-callback-return */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/* eslint-disable no-undef */

const OPTANON_SCRIPT_ELEMENT_ID = 'optanon-script';
const ENTER_KEY_ID = 13;
const ONETRUST_CLASS_AND_ID_NAME = 'cookie-preference';
const ONETRUST_SCRIPTS = {
  TEST: '25d8097d-9a5e-41c8-ab04-0114f1e8ff0b-test',
  PROD: '25d8097d-9a5e-41c8-ab04-0114f1e8ff0b',
};

// JSINFRA-426 Since we load one trust immediately, this method is not used anymore.
// const setUpOptanonBanner = () => {
//     // one trust script may not finish loading yet
//     if (typeof Optanon === 'undefined') {
//         setTimeout(() => {
//             setUpOptanonBanner();
//         }, 100);
//     } else {
//         Optanon.LoadBanner();
//         setTimeout(() => {
//             Optanon.ToggleInfoDisplay();
//         }, 50);
//     }
// };

const getOTDomainFromHostname = () => {
  if (typeof window !== 'undefined' && window?.location?.hostname?.includes('zillow.com')) {
    return ONETRUST_SCRIPTS.PROD;
  }

  return ONETRUST_SCRIPTS.TEST;
};

const loadOneTrustJSScript = () => {
  const optanonSetUpScript = document.createElement('script');
  optanonSetUpScript.id = OPTANON_SCRIPT_ELEMENT_ID;
  const dataDomainScriptAttr = document.createAttribute('data-domain-script');
  dataDomainScriptAttr.value = getOTDomainFromHostname();
  optanonSetUpScript.setAttributeNode(dataDomainScriptAttr);
  optanonSetUpScript.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
  optanonSetUpScript.type = 'text/javascript';
  // JSINFRA-1357 Since we load one trust immediately, do not show the banner when loaded.
  // optanonSetUpScript.onload = function() {
  //     setUpOptanonBanner();
  // };
  document.body.appendChild(optanonSetUpScript);
};

const toggleOrSetupOneTrust = () => {
  if (typeof Optanon === 'undefined') {
    loadOneTrustJSScript();
  } else {
    Optanon.ToggleInfoDisplay();
  }
};

const setupOneTrustEventListeners = (cookiePreferenceElement) => {
  if (cookiePreferenceElement) {
    cookiePreferenceElement.addEventListener('click', toggleOrSetupOneTrust);
  }

  if (cookiePreferenceElement && !cookiePreferenceElement.keydown) {
    cookiePreferenceElement.onkeydown = function (event) {
      if (event.keyCode === ENTER_KEY_ID) {
        toggleOrSetupOneTrust();
      }
    };
  }
};

const fetchCookiePreferenceElementsByClassName = () => {
  const cookiePreferenceClassElements = [];
  const cookiePrefElements = document.getElementsByClassName(ONETRUST_CLASS_AND_ID_NAME);
  for (let i = 0; i < cookiePrefElements.length; i++) {
    cookiePreferenceClassElements.push(cookiePrefElements[i]);
  }
  return cookiePreferenceClassElements;
};

export const setupOneTrustFooter = () => {
  if (document.getElementById(OPTANON_SCRIPT_ELEMENT_ID)) {
    return;
  }

  // JSINFRA-1357 load one trust on page load
  loadOneTrustJSScript();

  // backward compatibility with previous implementations, attach listeners to links with id as
  // cookie-preference
  const cookiePreferenceElement = document.getElementById(ONETRUST_CLASS_AND_ID_NAME);

  if (cookiePreferenceElement) {
    setupOneTrustEventListeners(cookiePreferenceElement);
  }

  const cookiePreferenceClassElements = fetchCookiePreferenceElementsByClassName();
  cookiePreferenceClassElements.map((cookiePrefElement) => {
    setupOneTrustEventListeners(cookiePrefElement);
  });
};
